import React from 'react';
import {
    IconBrandBluesky,
    IconBrandFacebook,
    IconBrandMessenger,
    IconBrandInstagram,
    IconBrandLinkedin,
    IconBrandPinterest,
    IconBrandTelegram,
    IconBrandWhatsapp,
    IconBrandXing,
    IconMail,
} from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';

// shareType doubles as the utm_source value, so its historical spelling (whatsApp,
// facebookMessenger) is kept; only the analytics class is mapped to its canonical name.
const ANALYTICS_CLASS_SUFFIX = {
    whatsApp: 'whatsapp',
    facebookMessenger: 'messenger',
};

const shareButton = (props) => {
    let button;
    let utmSource = props.shareType;
    const shareTitle = props.shareTitle;
    const rawShareText = props.shareText
        ? props.shareText
        : shareTitle
          ? `Hallo! Unterstütze uns indem du hier für ${shareTitle} abstimmst`
          : 'Jetzt für uns abstimmen!';
    const shareText = encodeURIComponent(rawShareText);
    const utmParams = `utm_source=${utmSource}&utm_medium=social&utm_campaign=${encodeURIComponent(props.campaign || 'Projektdetailsseite')}`;

    let shareUrl = props.shareUrl || props.url;
    if (!shareUrl) {
        const currentHref = typeof window !== 'undefined' ? window.location.href : '';
        shareUrl = currentHref + (currentHref.includes('?') ? `&${utmParams}` : `?${utmParams}`);
    }

    const isFlat = props.variant === 'flat' || props.variant === 'button' || props.flat;
    const analyticsClass = `anl_social-share--${ANALYTICS_CLASS_SUFFIX[props.shareType] || props.shareType}`;
    const baseClasses = isFlat
        ? `btn btn-light border d-inline-flex align-items-center justify-content-start text-dark text-decoration-none ps-3 pe-2 py-2 w-100 h-100 shadow-sm rounded-3 ${analyticsClass} ${props.className || ''}`.trim()
        : `${analyticsClass} d-flex align-items-center text-dark text-decoration-none p-1 ${props.className || ''}`.trim();

    const mailSubject = props.mailSubject || 'Jetzt für uns abstimmen!';
    const mailBody = props.mailBody ? `${props.mailBody}\n${shareUrl}` : `${rawShareText}: ${shareUrl}`;

    switch (props.shareType) {
        case 'email':
            button = (
                <a
                    href={`mailto:?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconMail color="#FFC234" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">E-Mail</span>
                </a>
            );
            break;
        case 'facebook':
            button = (
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    rel="external noopener noreferrer"
                    className={baseClasses}
                >
                    <IconBrandFacebook color="#375797" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">Facebook</span>
                </a>
            );
            break;
        case 'bluesky':
            button = (
                <a
                    href={`https://bsky.app/intent/compose?text=${shareText}%0A%0A${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    rel="external noopener noreferrer"
                    className={baseClasses}
                >
                    <IconBrandBluesky color="#457CBF" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">Bluesky</span>
                </a>
            );
            break;
        case 'whatsApp':
            button = (
                <a
                    href={`whatsapp://send?text=${shareText}%20${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconBrandWhatsapp color="#25D366" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">WhatsApp</span>
                </a>
            );
            break;
        case 'facebookMessenger':
            button = (
                <a
                    href={`fb-messenger://share/?link=${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconBrandMessenger color="#00B2FF" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">Messenger</span>
                </a>
            );
            break;
        case 'telegram':
            button = (
                <a
                    href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${shareText}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconBrandTelegram color="#229ED9" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">Telegram</span>
                </a>
            );
            break;
        case 'linkedin':
            button = (
                <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconBrandLinkedin color="#0077B5" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">LinkedIn</span>
                </a>
            );
            break;
        case 'xing':
            button = (
                <a
                    href={`https://www.xing.com/spi/shares/new?url=${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconBrandXing color="#126567" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">XING</span>
                </a>
            );
            break;
        case 'pinterest':
            button = (
                <a
                    href={`https://www.pinterest.com/pin/create/bookmarklet/?url=${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    className={baseClasses}
                    rel="noreferrer"
                >
                    <IconBrandPinterest color="#e60023" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">Pinterest</span>
                </a>
            );
            break;
        case 'instagram':
            button = (
                <NavLink className={baseClasses} to={props.instagramUrl || '../tipps'} exact>
                    <IconBrandInstagram color="#dd2a7b" size={24} className="flex-shrink-0" />
                    <span className="ps-2 text-nowrap">Instagram</span>
                </NavLink>
            );
            break;
        default:
            button = <span>Kein Dienst definiert</span>;
            break;
    }

    return button;
};

export default shareButton;
